import { jsx as _jsx } from "react/jsx-runtime";
export const PlayIcon = _ref => {
  let {
    width = 24,
    height = 24
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 12C16.9974 12.517 16.7624 13.0054 16.36 13.33L11.26 17.54L11.26 17.54C10.6336 18.042 9.77581 18.1429 9.05 17.8C8.41856 17.5217 8.00803 16.9 8 16.21V7.79003H8C8.00803 7.10002 8.41856 6.47836 9.05 6.20003H9.05C9.77581 5.8572 10.6336 5.95811 11.26 6.46003L16.36 10.67C16.7624 10.9947 16.9974 11.483 17 12Z",
      fill: "currentColor"
    })
  });
};